import script from "./The_Header.vue?vue&type=script&setup=true&lang=js"
export * from "./The_Header.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__